export const Fallback = () => (
	<div className="error-fallback">
		<h2>
			<i className="fa fa-warning"/>
			<span>予期せぬエラーが発生しました</span>
		</h2>
		<p>時間をおいて、再度お試しください</p>
	</div>
);